import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { newsletterSubmitter } from "./NewsletterSubmission";

function FormNotice({ status, message }) {
  if (!status) return null;
  return (
    <div
      className={`form-notice ${status === "success" ? "is-success" : "is-error"}`}
      role="status"
      aria-live="polite"
      style={{ marginTop: "1.6rem", color: "var(--slope-main-color)" }}
    >
      {message}
    </div>
  );
}

export function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", message: "" }); // idle | loading | success | error

  const emailOk = newsletterSubmitter.validateEmail(email).ok;
  const canSubmit = status.state !== "loading" && status.state !== "success" && emailOk;

  const onSubmit = async (e) => {
    e.preventDefault();

    const v = newsletterSubmitter.validateEmail(email);
    if (!v.ok) {
      setStatus({ state: "error", message: v.message });
      return;
    }

    try {
      setStatus({ state: "loading", message: "" });
      await newsletterSubmitter.submitEmail(email, { source: "footer" });
      setStatus({ state: "success", message: "Sent ✓" });
      setEmail("");
    } catch (err) {
      setStatus({
        state: "error",
        message: err?.message || "Subscription failed. Please try again.",
      });
    }
  };

  return (
    <form className="email-form" onSubmit={onSubmit} noValidate>
      <style>{`
        /* Keep it looking like your underline style */
        .email-form .email-form-field input[type="email"]{
          background: transparent !important;
          color: rgba(255,255,255,.92) !important;
          -webkit-text-fill-color: rgba(255,255,255,.92) !important;
          caret-color: rgba(255,255,255,.92) !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .email-form .email-form-field input[type="email"]:-webkit-autofill,
        .email-form .email-form-field input[type="email"]:-webkit-autofill:hover,
        .email-form .email-form-field input[type="email"]:-webkit-autofill:focus,
        .email-form .email-form-field input[type="email"]:-webkit-autofill:active{
          -webkit-text-fill-color: rgba(255,255,255,.92) !important;
          caret-color: rgba(255,255,255,.92) !important;

          /* THIS is the key: paint the background yourself (match footer bg) */
          -webkit-box-shadow: 0 0 0 1000px #000 inset !important;
          box-shadow: 0 0 0 1000px #000 inset !important;

          /* stops chrome flash */
          transition: background-color 9999s ease-out 0s !important;
        }

        /* Firefox autofill */
        .email-form .email-form-field input[type="email"]:-moz-autofill{
          box-shadow: 0 0 0 1000px #000 inset !important;
          -moz-text-fill-color: rgba(255,255,255,.92) !important;
          caret-color: rgba(255,255,255,.92) !important;
        }
      `}</style>

      <label>SUBSCRIBE</label>

      <div className="email-form-field">
        <span className="email">
          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-invalid={status.state === "error"}
            autoComplete="email"
          />
        </span>

        <button
          type="submit"
          disabled={!canSubmit}
          style={{ cursor: canSubmit ? "pointer" : "not-allowed" }}
          aria-label="Subscribe"
        >
          <FontAwesomeIcon icon={faCircleCheck} />
        </button>
      </div>

      <FormNotice
        status={status.state === "success" ? "success" : status.state === "error" ? "error" : ""}
        message={
          status.state === "loading"
            ? "Sending..."
            : status.state === "success"
            ? "Sent ➠ Thanks for your interest."
            : status.message
        }
      />
    </form>
  );
}
